import React, {useEffect, useState, useRef} from 'react'
import { Link } from "react-router-dom";
import { Link as Scroll } from "react-scroll";
import { useLocation } from "react-router-dom";

//Hero Image
import video from "../assets/heroImages/pltfrmHero2.mp4";

//Testimonials
import testimonial1 from "../assets/forFitnessEnthusiasts/Testimonials/testimonial1.png";
import testimonial2 from "../assets/forFitnessEnthusiasts/Testimonials/testimonial2.png";
import testimonial3 from "../assets/forFitnessEnthusiasts/Testimonials/testimonial3.png";

//Icons
import group from "../assets/forFitnessEnthusiasts/icons/groupIcon.png"
import shower from "../assets/forFitnessEnthusiasts/icons/showerIcon.png";
import laptop from "../assets/forFitnessEnthusiasts/icons/laptopIcon.png";
import weights from "../assets/forFitnessEnthusiasts/icons/weightsIcon.png";

import WellnessLiving from "../components/WellnessLivingWidget/WellnessLiving";

import "../styling/ForFitnessEnthusiasts.scss";

function ForFitnessEnthusiasts() {
     const location = useLocation();
    const elementRef1 = useRef(null);
    const elementRef2 = useRef(null);
     const [hasLoaded, setHasLoaded] = useState(false);
    
        useEffect(
            function () {
                if (location.pathname === "/forfitnessenthusiasts") {
                    elementRef1.current.scrollIntoView({
                        behavior: "smooth",
                    });
                } else if (
                    location.pathname === "/forfitnessenthusiasts/group-classes"
                ) {
                    elementRef2.current.scrollIntoView({
                        behavior: "smooth",
                    });
                }
                setHasLoaded(true)
            },
            [location]);
  return (
      <div>
          <header className="forFitnessHeader" ref={elementRef1}>
              <video
                  src={video}
                  autoPlay
                  muted
                  loop
                  playsInline
                  type="video/mp4"
                  id="myVideo"
              ></video>
              <div className="fitnessHeaderContent">
                  <div className="wrapper">
                      <div className="forFitnessHeader">
                          <h1>
                              A Private Training Gym & Coworking Space for
                              Fitness Enthusiasts
                          </h1>
                          <p>
                              An all-in-one gym different from anything you’ve
                              experienced
                          </p>
                          <div className="buttonContainer">
                              <button>
                                  <a href="https://calendly.com/pltfrm-fit/30mintour">
                                      BOOK A TOUR
                                  </a>
                              </button>

                              <button>
                                  <Scroll to="memberships" smooth={true}>
                                      MEMBERSHIPS
                                  </Scroll>
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
          </header>
          <section className="features">
              <div className="wrapper">
                  <div>
                      <h2>DEDICATED EQUIPMENT</h2>
                      <p>
                          You can book private alcoves to work out in. This
                          means you never have to wait for equipment. Come to
                          the gym and get your workout in without any
                          distractions!
                      </p>
                  </div>
                  <div>
                      <h2>SMALL GROUP CLASSES</h2>
                      <p>
                          Our group classes are designed to be intimate
                          experiences where you can get lots of 1-1 interaction
                          and guidance. Capped at 6 people, you are guaranteed
                          proper focus from your instructor.
                      </p>
                  </div>
                  <div>
                      <h2>
                          OPEN <br />
                          24/7
                      </h2>
                      <p>
                          PLTFRM is proud to be open 24/7. This means you get to
                          workout whenever you’d like to. Want to get a late
                          night session in? You can! Want to get an early
                          morning session in? You can!
                      </p>
                  </div>
              </div>
          </section>
          <section className="whatOurCommunitySays">
              <div className="wrapper">
                  <h2>WHAT OUR COMMUNITY SAYS ABOUT US</h2>
                  <div className="testimonials">
                      <img
                          src={testimonial1}
                          alt="Five Stars. Such a great class! Love the trainer. He worked with everyone to make sure we were using the correct form. A lot of care in this class and it's small. Loved it. Will be back. From classpass. Strength and conidtioning with Kareem."
                      />
                      <img
                          src={testimonial2}
                          alt="Five stars. The class was great! Tisha is knowledgeable, helpful, accomoodating and friendly. The class started with a long warm-up, which I definitely appreciated. The facilities are clean and the location is convenient too. I'll be back! From classpass. Kettlebell burn with Tisha."
                      />
                      <img
                          src={testimonial3}
                          alt="Five stars. Intimate venue. Excellent full-body workout. Small class sizes which means the coach can focus on eaech participant to ensure good technique. From classpass. Stength and conditioning with Kareem."
                      />
                  </div>
                  <div className="testimonialButton">
                      <button>
                          <a href="https://calendly.com/pltfrm-fit/30mintour">
                              BOOK A TOUR
                          </a>
                      </button>
                  </div>
              </div>
          </section>
          <section className="accessSpace">
              <div className="wrapper">
                  <h2>
                      Enjoy 24/7 Access to Toronto’s Premier Private Training
                      Gym and Coworking Space
                  </h2>
                  <div className="benefitContainer">
                      <div>
                          <img src={group} alt="Grou[ classes icon" />
                          <h4>WEEKLY GROUP CLASSES</h4>
                      </div>
                      <div>
                          <img src={weights} alt="Weight icon" />
                          <h4>BOOK PRIVATE WORKOUT ALCOVES</h4>
                      </div>
                      <div>
                          <img src={laptop} alt="Laptop icon" />
                          <h4>ACCESS COWORKING & LOUNGE SPACES</h4>
                      </div>
                      <div>
                          <img src={shower} alt="Shower icon" />
                          <h4>ONSITE SHOWERS & CHANGING ROOMS</h4>
                      </div>
                  </div>
              </div>
          </section>
          <section className="enthusiastsMembership" name="memberships">
              <div className="wrapper">
                  <div className="memberShipContainer">
                      <h2>FITNESS ENTHUSIAST MEMBERSHIP</h2>
                      <p>
                          This membership is designed for members for our
                          community who want to use PLTFRM as their home gym.
                          You can book private alcoves & get access to all group
                          classes on this membership.
                      </p>
                      <div className="memberOption">
                          <div className="membershipInfo">
                              <div>
                                  <h4>SINGLE-PERSON UNLIMITED MEMBERSHIP</h4>
                                  <h2>Basic</h2>
                                  <ul>
                                      <li>Unlimited Training Hours</li>
                                      <li>24/7 PLTFRM access</li>
                                      <li>Coworking spaces access</li>
                                      <li>
                                          Unlimited access to group classes
                                          based on availability
                                      </li>
                                  </ul>
                              </div>
                              <h3>
                                  $150 <span>per month + tax</span>
                              </h3>
                          </div>
                          <div className="buttonContainer">
                              <button>
                                  <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=5&k_id=3446139">
                                      JOIN
                                  </a>
                              </button>
                          </div>
                      </div>
                      <h4 className="disclaimer">
                          TRAINING SESSIONS ARE 1 HOUR. YOU CAN BOOK 1 ALCOVE
                          PER HOUR
                      </h4>
                  </div>
              </div>
          </section>
          <section className="groupPassAccess" ref={elementRef2}>
              <div className="wrapper">
                  <h2>ACCESS GROUP CLASSES</h2>
                  <p>
                      If you are on our membership you get unlimited access to
                      all classes for free. Single classes cost $37 per class.
                      Can be bought at checkout
                  </p>
                  <div className="classPassList">
                      <div className="classPass">
                          <div className="classInfo">
                              <h4>VALID FOR 3 MONTHS</h4>
                              <h2>5 CLASS PASS</h2>
                              <h3>
                                  $70 <span>+ tax</span>
                              </h3>
                          </div>
                          <button>
                              <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=1&k_id=3446339">
                                  JOIN
                              </a>
                          </button>
                      </div>
                      <div className="classPass">
                          <div className="classInfo">
                              <h4>VALID FOR 4 MONTHS</h4>
                              <h2>10 CLASS PASS</h2>
                              <h3>
                                  $100 <span>+ tax</span>
                              </h3>
                          </div>
                          <button>
                              <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=1&k_id=3446344">
                                  JOIN
                              </a>
                          </button>
                      </div>
                      <div className="classPass">
                          <div className="classInfo">
                              <h4>RENEWS MONTHLY</h4>
                              <h2>MONTHLY UNLIMITED</h2>
                              <h3>
                                  $60 <span>per month + tax</span>
                              </h3>
                          </div>
                          <button>
                              <a href="https://www.wellnessliving.com/rs/catalog-view.html?k_business=416410&id_sale=1&k_id=3446175">
                                  JOIN
                              </a>
                          </button>
                      </div>
                  </div>
              </div>
          </section>
          <section className="groupClasses">
              <div className="wrapper">
                  <h2>GROUP CLASSES</h2>
                  <div className="classList">
                      <div className="classOption">
                          <div className="info">
                              <h4>STRENGTH AND CONDITIONING</h4>
                              <p>
                                  This class combines weightlifting, functional
                                  movements, and cardio drills to build muscle,
                                  burn fat, and enhance overall athletic
                                  performance.
                              </p>
                          </div>
                          <p>SUNDAYS AT 9AM</p>
                      </div>
                      <div className="classOption">
                          <div className="info">
                              <h4>SCULPT AND STRENGTH</h4>
                              <p>
                                  This program alternates weekly between lower
                                  and upper body workouts, using targeted
                                  exercises designed to maximize muscle growth.
                                  Perfect for those looking to increase size,
                                  strength, and overall performance in a fun,
                                  supportive group setting.
                              </p>
                          </div>
                          <p>THURSDAYS AT 7PM</p>
                      </div>
                      <div className="classOption">
                          <div className="info">
                              <h4>KETTLEBELL BURN</h4>
                              <p>
                                  Kettlebell Burn is a dynamic full-body
                                  strength class designed to challenge and tone
                                  every muscle.
                              </p>
                          </div>
                          <p>SATURDAYS 11AM</p>
                      </div>
                  </div>
              </div>
          </section>
          <section className="wellnessLiving">
              <div className="wrapper">
                  <h2>CLASS SCHEDULE</h2>
                  <WellnessLiving load={hasLoaded} />
              </div>
          </section>
          <section className="bookATour">
              <div className="wrapper">
                  <p className="enthusiastsBookTrainer">
                      Looking for a personal trainer? Check out our{" "}
                      <Link to="/ourtrainers">trainer profiles</Link> and fill
                      out our form and our team will reach out with next steps.
                  </p>
                  <div className="bookATourButtonContainer">
                      <h2>Book a tour</h2>
                      <p>
                          Ready to find out if PLTFRM is your home? Book a tour
                          and let’s chat about what we can do for you!
                      </p>
                      <button>
                          <a href="https://calendly.com/pltfrm-fit/30mintour">
                              BOOK A TOUR
                          </a>
                      </button>
                  </div>
              </div>
          </section>
          <section className="haveAQuestion forFitnessHaveAQ">
              <div className="wrapper">
                  <h2>
                      Have a question? Checkout our <Link to="/faq">FAQ</Link>
                  </h2>
              </div>
          </section>
      </div>
  );
}

export default ForFitnessEnthusiasts